import { Input } from '@/components/ui/input'
import { useSearchTerm } from '../state/filters'

export default function SearchSignatures() {
  const [searchTerm, setSearchTerm] = useSearchTerm()
  return (
    <Input
      placeholder="Buscar por CPF, nome ou tipo"
      value={searchTerm}
      onChange={e => setSearchTerm(e.target.value)}
      className="w-full md:w-1/3 bg-input"
    />
  )
}
